import "fwkits-core-presentation-vue/assets/vendor/nucleo/css/nucleo.css";
import "fwkits-core-presentation-vue/assets/scss/argon.scss";
import "@/assets/scss/resimple.scss";
import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives";
import SidebarPlugin from "@/components/SidebarPlugin/index"
import NotificationPlugin from "@/components/NotificationPlugin/index"

export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
    Vue.use(SidebarPlugin);
    Vue.use(NotificationPlugin);
  }
};
